'use strict';

angular.module('directives.iamEvent')

.controller('iamEventSummaryTransferController', ['$scope', 'employeeService', function ($scope, employeeService) {
   
    if ($scope.boxContext && $scope.boxContext.ShowDetails) {

        // Get Employee Or Matching
        employeeService
          .getBasicInfosOnEmployeeOrMatchingEmployee($scope.model.EventGroupID)
          .then(function (response) {
              $scope.employee = response.data;
          });

        // Get Pending Employee
        employeeService
            .getPendingEmployeeBasicInfos($scope.model.EmployeeID)
            .then(function (response) {
                $scope.pendingEmployee = response.data;
            });
    }
  

    // Show Current And Pending Employees?
    $scope.showCurrentAndPendingEmployees = function () {
        if (!_.isObject($scope.employee)) return;
        if (!_.isObject($scope.pendingEmployee)) return;

        return true;
    };

}]);